// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box{height:800px}.el-scrollbar{height:100%}.box .el-scrollbar__wrap{overflow:scroll}.w-calc-300{width:calc(100% - 300px)}", ""]);
// Exports
module.exports = exports;
